import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

// the HTTP status behind a non-JSON body, which RTK Query reports as PARSING_ERROR - undefined for any other failure
export const getOriginalStatus = (response: FetchBaseQueryError): number | undefined =>
    response.status === "PARSING_ERROR" ? response.originalStatus : undefined;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

// the HTTP status behind a non-JSON body, which RTK Query reports as PARSING_ERROR - undefined for any other failure
export const getOriginalStatus = (response: FetchBaseQueryError): number | undefined =>
    response.status === "PARSING_ERROR" ? response.originalStatus : undefined;
